import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CardContent, Grid, Typography, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import { LanguageContext } from '../../../../../../libs/Context';
import { useSelector } from 'react-redux';
import CommonEventCard from '../../../Reusable/CommonEventCard';
import Comments from '../../../Reusable/Comments';
import { feedActionContext } from '../../../..';
import { reactions } from '..';
import { CustomNextArrow, CustomPrevArrow } from './CustomButtons';
import ReactionSlector from './ReactionSlector';
import { useTheme } from '@mui/material/styles';
const DEFAULT_REACTION_IMG = '/images/icons/smily.svg';

const EventCardCarousel = (props:any) =>
{
	const { handleSelEvent, selEvent, getEventsData } = props;
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down(1300));

	// redux-action..
	const eventData: any = useSelector((state: any) => state?.mynewsFeed?.eventData);
	const { type } = useParams();

	// context
	const { feedCardActn } = useContext(feedActionContext);
	const { language } = useContext(LanguageContext);

	// ref..
	const scrollContainerRef = useRef<HTMLDivElement | null>(null);

	// state management...
	const [ isHovering, setIsHovering ] = useState(false);
	const [ currentIndex, setCurrentIndex ] = useState(0);
	const [ eventState, setEventState ] = useState<any>({
		isLoading     : false,
		openComment   : type === 'celebrationevents' && feedCardActn[0] === 'allEventCmnt',
		openReaction  : false,
		reactionImg   : DEFAULT_REACTION_IMG,
		anchorEl      : null,
		reactionData  : [],
		selectedEvent : {}
	});
	const { openComment } = eventState;

	// based on initial data, updating local state for further actions.
	useEffect(() =>
	{
		if (selEvent && Object.keys(selEvent)?.length > 0)
		{
			const selectedReaction:any = selEvent?.reactionData?.length > 0
				? reactions.find(
					(reaction) => reaction?.key === selEvent?.reactionData[0]?.type
				)
				: {};

			setEventState((prev:any) => ({
				...prev,
				reactionData  : selectedReaction,
				selectedEvent : selEvent ?? {},
				reactionImg   : selectedReaction?.imgSrc ?? DEFAULT_REACTION_IMG
			}));
		}
	}, [ selEvent ]);

	// nav...
	const navigate = useNavigate();

	/* Section-A*/
	const handleScroll = (direction: 'left' | 'right') =>
	{
		const container = scrollContainerRef.current;

		if (container)
		{
			const scrollAmount = direction === 'left' ? -200 : 200;

			container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		}
	};

	// if crousal index get chnaged then reaction data need to update.
	// after change of crousal card... handleSelEvent trigger
	const handleAfterChange = (newIndex) =>
	{
		setCurrentIndex(newIndex);
		handleSelEvent(newIndex);
	};

	// crousal action
	const settings = {
		dots           : true,
		infinite       : true,
		speed          : 500,
		slidesToShow   : 1,
		slidesToScroll : 1,
		arrows         : true,
		prevArrow      : <CustomPrevArrow onClick={() => handleScroll('left')} isHovering={isHovering}/>,
		nextArrow      : <CustomNextArrow onClick={() => handleScroll('right')} isHovering={isHovering}/>,
		afterChange    : handleAfterChange
	};

	/* Section-B*/
	const handleClick = (event:any) =>
	{
		setEventState((prev:any) => ({ ...prev, anchorEl: event.currentTarget }));
	};
	const handleOpenComment = () =>
	{
		setEventState((prev:any) => ({ ...prev, openComment: true, openReaction: false }));
	};
	const handleClose = () =>
	{
		setEventState((prev:any) => ({ ...prev, anchorEl: null }));
	};
	const sliderProps = feedCardActn[0] === 'allEventCmnt' ? {} : settings;
	const updatedEventData = feedCardActn[0] === 'allEventCmnt' ? feedCardActn[1] : eventData;

	return (
		<>
			{eventData && eventData?.length > 0 &&
				(
					<Box
						onMouseEnter={() => setIsHovering(true)}
						onMouseLeave={() => setIsHovering(false)}
					>
						{![ 'celebrationevents' ]?.includes(type ?? '')
							? <Slider {...sliderProps} className={`${downSM ? 'eventWishCards1' : 'eventWishCards'} fullHeight`}>
								{eventData?.slice(0, 3)?.map((item:any, index:any) => (
									<CommonEventCard
										eachEvent={feedCardActn[0] === 'allEventCmnt' ? feedCardActn[1] : item}
										index={index}
										key={item?._id}
									/>

								))}
								<Grid item xs={12}>
									<Box
										alignItems='center'
										justifyContent='center'
										display='flex'
										sx={{
											borderRadius : 'var(--pixel8)',
											cursor       : 'pointer',
											width        : 'var(--percent100)',
											position     : 'relative',
											height       : downSM ? '156px' : '175px',
											overflow     : 'hidden'
										}}
									>
										<Box
											sx={{
												position     : 'absolute',
												top          : 0,
												left         : 0,
												width        : '100%',
												height       : '100%',
												background   : '#24A4C4',
												opacity      : 0.3,
												borderRadius : 'var(--pixel8)'
											}}
										/>
										{/* Content Box */}
										<CardContent
											sx={{
												display        : 'flex',
												flexDirection  : 'column',
												justifyContent : 'center',
												height         : 'var(--percent100)',
												position       : 'relative',
												zIndex         : 1,
												maxWidth       : '300px',
												alignItems     : 'center'
											}}
										>
											<Typography
												onClick={() => navigate('/news/celebrationevents')}
												variant='inherit'
												sx={{ zIndex: 2 }}
												color='var(--primaryColor)'
											>
												{language?.viewAll}
											</Typography>
										</CardContent>
									</Box>
								</Grid>
							</Slider>
							: <Grid item xs={12}>
								<CommonEventCard
									eachEvent={updatedEventData}
									index={0}
									key={eventData?._id}
								/>
							</Grid>
						}
					</Box>
				)
			}

			{eventData && eventData?.length > 0 && <Grid item xs={12}>
				{/* Emoji Component for events*/}
				{(currentIndex <= eventData?.length - 1 || [ 'celebrationevents' ]?.includes(type ?? '')) &&
				<ReactionSlector
					eventState={eventState} handleClose={handleClose}
					setEventState={setEventState} handleOpenComment={handleOpenComment}
					handleClick={handleClick} getEventsData={getEventsData}
				/>}
				{/* Comments Component for Feeds and Events */}
				{(currentIndex <= eventData?.length - 1 || [ 'celebrationevents' ]?.includes(type ?? '')) &&
				(openComment) &&
				(
					<Comments
						setOpenComment={setEventState}
						openComment={openComment}
						selEvent={type === 'celebrationevents' ? updatedEventData : selEvent}
						from='events'
					/>
				)}
			</Grid>
			}
		</>
	);
};

export default EventCardCarousel;

/**
 * If you are modifying any functions or components,
 * kindly check the dependencies in terms of feeds
 * and events.
 * 
 * Last update: 09-JAN-2025
 * 
 */
